module.exports = __webpack_public_path__ + "static/media/heart-empty.e924d4de.svg";